var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('Header'),_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.scrollToTop),expression:"scrollToTop"}]}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }